export const FeatureCodes = {
  EMS: {
    application: 'APPLICATIONS',
    statusTemplate: 'STATUS-TEMPLATE',
    applicationSearch: 'APPLICATION-SEARCH',
    applicationEnrollment: 'APP-ENROLMENT',
    assignIntake: 'ASSIGN-INTAKE',
    admission: 'ADMISSION',
    studentManagement: 'STUDENT-MANAGEMENT',
    admittedStudent: 'ADMITTED-STUDENT-EMS',
    academicTranscript: 'ACADEMIC-TRANSCRIPT-EMS',
    assignStudentSupport: 'ASSIGN-STUDENT-SUPPORT',
    corporateStudents: 'CORPORATE-STUDENT',
    corporate: 'CORPORATE',
    projectManagement: 'PROJECT-MANAGEMENT',
    graduateStudent: 'GRADUATE-STUDENT',
    generateReggieNumber: 'GENERATE-REGGIE-NUMBER',
    generateQuote: 'GENERATE-QUOTE',
    manageRollover: 'MANAGE-ROLLOVER'
  },
  AMS: {
    qualificationAndModule: 'QUALIFICATION-MODULE',
    groups: 'GROUPS',
    RMATConfiguration: 'RMAT-CONFIG',
    academicIntake: 'ACADEMIC-INTAKE',
    academicTranscripts: 'ACADEMIC-TRANSCRIPT-ADS', //In both AMS and ADS
    admittedStudent: 'ADMITTED-STUDENT-ADS', //In both AMS and ADS
    moduleAcademicReport: 'MODULE-ACADEMIC-REPORT', //In both AMS and ADS
    assessmentDashboard: 'ASSESSMENT-DASHBOARD', //In both AMS and ADS
    manageDepartments: 'MANAGE-DEPARTMENT',
    examRoomManagement: 'EXAM-ROOM-MANAGEMENT', //In both AMS and ADS
    viewAndDownloadGraduation: 'VIEW-AND-DOWNLOAD-GRADUATION', //In both AMS and ADS
    manageVenues: 'MANAGE-VENUE',
    examSchedule: 'EXAM-SCHEDULE', //In both AMS and ADS
    courseProfile: 'COURSE-PROFILE',
    manageSchedules: 'MANAGE-SCHEDULE',
    classManagement: 'CLASS-MANAGEMENT-ADS',
    manageFacilitator: 'MANAGE-FACILITATOR',
    viewExamAttendance: 'EXAM-ATTENDENCE' //In both AMS and ADS
  },
  FMS: {
    applicationProofOfPayment: 'APP-PROOF-PAYMENT',
    discount: 'DISCOUNT',
    fees: 'FEES',
    admittedStudent: 'ADMITTED-STUDENT-FMS',
    manageConversionRate: 'MANAGE-CONVERSION-RATE',
    monthlyPaymentStudent: 'FINANCIAL-APPROVAL',
    bursaryApplications: 'BURSARY-APPLICATION',
    VIPStudents: 'VIP-STUDENT-FMS',
    manageOtherFees: 'MANAGE-OTHER-FEES'
  },
  OMS: {
    classManagement: 'CLASS-MANAGEMENT-OMS',
    attendanceManagement: 'ATTENDANCE-MANAGEMENT',
    AdmittedStudentList: 'ADMITTED-STUDENT-OMS',
    UnenrolledStudent: 'UNENROLLED-STUDENT',
    viewAndDownloadGraduation: 'VIEW-AND-DOWNLOAD-GRADUATION-OMS',
    queryDashboard: 'QUERY-DASHBOARD',
    ACFormDashboard: 'ACFORM-DASHBOARD',
    VIPStudents: 'VIP-STUDENT-OMS',
    orientationSchedule: 'ORIENTATION-SCHEDULE',
    throughputReport: 'THROUGHPUT-REPORT',
    riskDashboard: 'RISK-DASHBOARD',
    progressReportAndTranscripts: 'PROGRESS-REPORT-TRANSCRIPT-OMS',
    aiRiskProfile: 'AI-RISK-PROFILE',
    examProctoring: 'EXAM-PROCTORING'
  },
  UMS: {
    dashboard: 'UMS-DASHBOARD',
    manageUserRoleAndPermission: 'MANAGE-USER-ROLE-AND-PERMISSION'
  },
  AAMS: {
    academicTranscripts: 'ACADEMIC-TRANSCRIPT-AMS',
    admittedStudent: 'ADMITTED-STUDENT-AMS',
    moduleAcademicReport: 'MODULE-ACADEMIC-REPORT-AMS',
    assessmentDashboard: 'ASSESSMENT-DASHBOARD-AMS',
    examRoomManagement: 'EXAM-ROOM-MANAGEMENT-AMS',
    manageExamCategoryAndType: 'MANAGE-EXAM-CATEGORY-AND-TYPE',
    viewAndDownloadGraduation: 'VIEW-AND-DOWNLOAD-GRADUATION-AMS',
    examSchedule: 'EXAM-SCHEDULE-AMS',
    viewExamAttendance: 'EXAM-ATTENDENCE-AMS',
    manageFacilitator: 'MANAGE-FACILITATOR-AMS',
    classManagement: 'CLASS-MANAGEMENT-AMS',
    manageVenues: 'MANAGE-VENUE-AMS'
  },
  CES: {
    corporateStudents: 'CORPORATE-STUDENT',
    corporate: 'CORPORATE',
    corporateStudentManagement: 'CORPORATE-STUDENT-MANAGEMENT',
    projectManagement: 'PROJECT-MANAGEMENT',
    corporateGroup: 'CORPORATE-GROUP',
    corporateManager: 'CORPORATE-MANAGER'
  },
  MIS: {
    nlrdReport: 'NLRD-REPORT',
    dhetReport: 'DHET-REPORT',
    graduationReport: 'GRADUATION-REPORT',
    throughputRate: 'THROUGHPUT-RATE',
    progressionRate: 'PROGRESSION-RATE',
    successRate: 'SUCCESS-RATE',
    statusReport: 'STATUS-REPORT',
    rolloverReport: 'ROLLOVER-REPORT',
    admissionReport: 'ADMISSION-REPORT',
    assessmentReport: 'ASSESSMENT-REPORT'
  },
  HOD: {
    electiveModuleMonitoring: 'ELECTIVE-MODULE-MONITORING'
  }
}

export const moduleKeys = {
  finance: 'finance',
  admin: 'admin',
  sales: 'sales',
  admission: 'admission',
  academics: 'academics',
  assessment: 'assessment',
  assessmentOther: 'assessmentOther',
  corporateSales: 'corporatesales',
  operation: 'operation',
  adminSales: 'adminsales',
  adminFinance: 'adminfinance',
  adminAdmission: 'adminadmission',
  adminAcademics: 'adminacademics',
  adminAssessment: 'adminassessment',
  adminOperation: 'adminoperation',
  user: 'usermanagement',
  corporate: 'corporate',
  misreport: 'misreport',
  hod: 'hod'
}

export const RoleCodes: any = {}
RoleCodes[moduleKeys.finance] = 'Finance'
RoleCodes[moduleKeys.admin] = 'Admin'
RoleCodes[moduleKeys.sales] = 'Sales'
RoleCodes[moduleKeys.admission] = 'Admission'
RoleCodes[moduleKeys.academics] = 'Academics'
RoleCodes[moduleKeys.assessment] = 'Assessment'
RoleCodes[moduleKeys.operation] = 'Operation'
RoleCodes[moduleKeys.adminSales] = 'Admin_Sales'
RoleCodes[moduleKeys.adminFinance] = 'Admin_Finance'
RoleCodes[moduleKeys.adminAdmission] = 'Admin_Admission'
RoleCodes[moduleKeys.adminAcademics] = 'Admin_Academics'
RoleCodes[moduleKeys.adminAssessment] = 'Admin_Assessment'
RoleCodes[moduleKeys.adminOperation] = 'Admin_Operation'

export const ModuleCodes: any = {}

ModuleCodes[moduleKeys.finance] = 'FMS'
ModuleCodes[moduleKeys.academics] = 'ADS'
ModuleCodes[moduleKeys.assessment] = 'AAMS'
ModuleCodes[moduleKeys.sales] = 'EMS'
ModuleCodes[moduleKeys.operation] = 'OMS'
ModuleCodes[moduleKeys.user] = 'UMS'
ModuleCodes[moduleKeys.corporate] = 'CES'
ModuleCodes[moduleKeys.hod] = 'HOD'

export const PermissionsCodes: any = {
  view: 'VIEW',
  none: 'NONE',
  full: 'FULL'
}

export const MenuTitles: any = {}
MenuTitles[moduleKeys.finance] = 'Finance Management'
MenuTitles[moduleKeys.academics] = 'Academic Delivery System'
MenuTitles[moduleKeys.operation] = 'Operations Management'
MenuTitles[moduleKeys.sales] = 'Enrolment Management'
MenuTitles[moduleKeys.user] = 'User Management'
MenuTitles[moduleKeys.assessment] = 'Assessment Management System'
MenuTitles[moduleKeys.corporate] = 'Corporate Education System'
MenuTitles[moduleKeys.assessmentOther] = 'Others'
MenuTitles[moduleKeys.misreport] = 'Mis Report Management'

export const url = {
  classManagement: 'class-management',
  attendanceManagement: 'attendance-management',
  admittedStudentsList: 'admitted-students-list',
  queryDashboard: 'query-dashboard',
  viewAndDownloadGraduationList: 'view-and-download-graduation-list',
  vipStudents: 'vip-students',
  orientationSchedule: 'orientationSchedule',
  throughputReport: 'throughput-report',
  riskDashboard: 'risk-dashboard',
  electiveModuleMonitoring: 'elective-module-monitoring',
  examProctoring: 'exam-proctoring',
  aiRiskProfile: 'ai-risk-profile'
}

export const UrlToModule: any = {}
UrlToModule[url.classManagement] = FeatureCodes.OMS.classManagement
UrlToModule[url.attendanceManagement] = FeatureCodes.OMS.attendanceManagement
UrlToModule[url.admittedStudentsList] = FeatureCodes.OMS.AdmittedStudentList
UrlToModule[url.queryDashboard] = FeatureCodes.OMS.queryDashboard
UrlToModule[url.viewAndDownloadGraduationList] = FeatureCodes.OMS.viewAndDownloadGraduation
UrlToModule[url.vipStudents] = FeatureCodes.OMS.VIPStudents
UrlToModule[url.orientationSchedule] = FeatureCodes.OMS.orientationSchedule
UrlToModule[url.throughputReport] = FeatureCodes.OMS.throughputReport
UrlToModule[url.riskDashboard] = FeatureCodes.OMS.riskDashboard
UrlToModule[url.electiveModuleMonitoring] = FeatureCodes.HOD.electiveModuleMonitoring
UrlToModule[url.examProctoring] = FeatureCodes.OMS.examProctoring
UrlToModule[url.aiRiskProfile] = FeatureCodes.OMS.aiRiskProfile
